import React, {Fragment} from "react";
import {Bonus} from "@App/types";

type GarageListItemBonuses = {
    bonuses: Bonus[]
    headline: string
    shortDescription?: boolean
};


export const GarageListItemBonuses = React.memo<GarageListItemBonuses>((props: GarageListItemBonuses) => {
    return (
        <Fragment>
            <div className="mb-2 font-bold">{props.headline}</div>
            {props.bonuses.map((bonus, index) => (
                <div key={index} className={'flex gap-1 mb-1'}>
                    {bonus.icon === 'warning' && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
                            <path fill="#E8B12E"
                                  d="M8.637 7.108l.229 3.889c.013.22.195.392.416.392h1.436c.22 0 .403-.172.416-.392l.229-3.89c.014-.239-.176-.44-.416-.44H9.053c-.24 0-.43.201-.416.44zm2.821 6.225c0 .806-.653 1.459-1.458 1.459-.805 0-1.458-.653-1.458-1.459 0-.805.653-1.458 1.458-1.458.805 0 1.458.653 1.458 1.458zm-.014-12.5c-.64-1.11-2.246-1.112-2.888 0L.225 15.278c-.64 1.109.161 2.5 1.444 2.5H18.33c1.28 0 2.085-1.389 1.444-2.5L11.444.833zM1.847 15.799L9.82 1.979c.08-.139.28-.139.36 0l7.973 13.82c.08.139-.02.312-.18.312H2.027c-.16 0-.26-.173-.18-.312z"/>
                        </svg>
                    )}
                    {bonus.icon === 'checkmark' && (
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20"
                             height="16"
                             viewBox="0 0 20 16">
                            <defs>
                                <path id="prefix__a" d="M0 0L19.99 0 19.99 15.393 0 15.393z"/>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                                <mask id="prefix__b" fill="#fff">
                                    <use xlinkHref="#prefix__a"/>
                                </mask>
                                <path fill="#56B556"
                                      d="M17.858.154l-11.5 11.5-4.226-4.226c-.205-.205-.537-.205-.742 0L.154 8.665c-.205.204-.205.537 0 .742l5.833 5.833c.204.204.537.204.742 0L19.836 2.132c.205-.205.205-.537 0-.742L18.599.154c-.204-.205-.537-.205-.741 0"
                                      mask="url(#prefix__b)"/>
                            </g>
                        </svg>
                    )}
                    {props.shortDescription ? bonus.name : bonus.description}
                </div>
            ))}
        </Fragment>
    );
})
